export default {
  SHOW_CAPTCHA: 'ott/limiter/SHOW_CAPTCHA',
  CHECK_CAPTCHA: 'ott/limiter/CHECK_CAPTCHA',
  RESET_CAPTCHA: 'ott/limiter/RESET_CAPTCHA',
};
